export const enum MyAccountMenuViewCssSelectorEnum {
  userInfo = '[data-qs=user-info]',
  savedProperty = '[data-qs=saved-property]',
  contactedProperty = '[data-qs=contacted-property]',
  myNotesProperty = '[data-qs=my-notes-property]',
  myNotesLink = '[data-qs=my-notes-link]',
  myAccountOriginalContent = '[data-qs=my-account-original-content]',
  userForm = '[data-qs=user-form]',
}
